import { RootState } from '@reducers/index';
import { Submission } from 'src/types/shared/Assessments';

export const getSubmissionsIsFetching = (state: RootState): boolean =>
    state.submissionsReducer.isFetching;
export const getSubmissionsFetchError = (state: RootState): string | null =>
    state.submissionsReducer.fetchError;
export const getSubmissionsIsDeleting = (state: RootState): boolean =>
    state.submissionsReducer.isDeleting;
export const getSubmissionsDeleteError = (state: RootState): string | null =>
    state.submissionsReducer.deleteError;
export const getSubmissionsDeleteSuccess = (state: RootState): boolean =>
    state.submissionsReducer.deleteSuccess;

export const getSubmissions = (state: RootState): Record<number, Submission> =>
    state.submissionsReducer.submissions;
export const getSubmission = (state: RootState, id: number): Submission =>
    state.submissionsReducer.submissions[id];
